// Dashboard Utilities.

import { independentSystemWidgetIds } from './constants';

export const getDashboardLayoutColumns = (grid: string): string[] | undefined => {
  if (!grid) return;
  return grid?.split('-');
};

export const getIsIndependentSystemWidget = (widgetId: string): boolean => {
  if (!widgetId) return false;
  const independentWidgets = Object.values(independentSystemWidgetIds);
  if (independentWidgets.includes(widgetId)) return true;
  return false;
};
